var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = _vm.itemData.data.length
  var l0 =
    g0 > 0
      ? _vm.__map(_vm.itemData.data, function (item, index) {
          var $orig = _vm.__get_orig(item)
          var a0 = {
            startstamp: new Date().valueOf() / 1000,
            endstamp: item.preview_time,
            title: " ",
          }
          return {
            $orig: $orig,
            a0: a0,
          }
        })
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        l0: l0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }